import angular from 'angular';

import { CONSTANTS } from 'config';

import template from './footer.html';
import './footer.styl';

function footerComponent($mdDialog, $localStorage, $analytics) {

  'ngInject';

  $analytics.setOptOut(false);

  this.showCookiesDialog = (ev) => {
    this.showDialog(ev, 'cookies');
  };

  this.showLegalNoticeDialog = (ev) => {
    this.showDialog(ev, 'legal_notice');
  };

  this.showPrivacyPolicyDialog = (ev) => {
    this.showDialog(ev, 'privacy_policy');
  };

  this.showUsageTermsDialog = (ev) => {
    this.showDialog(ev, 'usage_terms');
  };

  this.showDialog = (ev, modal, clickOutsideToClose = true, escapeToClose = true) => {
    $mdDialog.show({
      controller: ($scope) => {
        $scope.close = () => {
          $mdDialog.hide();
        };
        $scope.accept = () => {
          $localStorage[CONSTANTS.COOKIES_ACCEPTED] = true;
          $analytics.setOptOut(false);
          $mdDialog.hide();
        };
        $scope.showCookieDetail = () => {
          console.log('clicked');
          $scope.isCookieDetailVisible = true;
        };
      },
      controllerAs: 'ctrl',
      templateUrl: `/static/modals/${modal}.html`,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose,
      escapeToClose,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

  this.checkCookies = (ev) => {

    if (!$localStorage[CONSTANTS.COOKIES_ACCEPTED]) {
      this.showDialog(ev, 'accept_cookies', false, false);
    }

    $analytics.setOptOut(!$localStorage[CONSTANTS.COOKIES_ACCEPTED]);
  };

  this.init = () => {
    this.checkCookies();
  };

  this.init();
}

export default {
  template,
  controller: footerComponent,
};



// WEBPACK FOOTER //
// ./src/containers/footer/footer.js